import { Link } from "react-router-dom";
import { CATEGORIES, HERO_IMAGE } from "../data/categories";
import { useEffect, useState } from "react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import Logo from "../components/Logo";
import WelcomeGate from "../components/WelcomeGate";
import { useCart } from "../contexts/CartContext";

export default function Home() {
    const { deliveryType, setDeliveryType } = useCart();
    const [featured, setFeatured] = useState([]);

    useEffect(() => {
        api.get("/menu/items")
            .then((r) => {
                const items = r.data || [];
                const pick = [];
                ["sandwiches", "snacks", "drinks"].forEach((cat) => {
                    const it = items.find((x) => x.category === cat);
                    if (it) pick.push(it);
                });
                setFeatured(pick);
            })
            .catch(() => {});
    }, []);

    if (!deliveryType) {
        return <WelcomeGate />;
    }

    return (
        <div data-testid="home-page">
            {/* Delivery banner */}
            <section className="bg-gradient-to-l from-[#FFEFD9] to-[#FFF8F0] border-b border-[var(--border-subtle)]">
                <div className="max-w-md mx-auto md:max-w-2xl lg:max-w-5xl px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-text-main text-sm">
                        <i className={`fa-solid ${deliveryType === "car" ? "fa-car" : "fa-location-dot"} text-brand`} />
                        <span className="font-bold">
                            {deliveryType === "car" ? "توصيل للسيارة" : "توصيل للموقع"}
                        </span>
                    </div>
                    <button
                        onClick={() => setDeliveryType(null)}
                        data-testid="change-delivery-type"
                        className="text-xs text-brand font-bold hover:underline"
                    >
                        <i className="fa-solid fa-arrows-rotate ms-1" /> تغيير
                    </button>
                </div>
            </section>

            {/* Hero */}
            <section
                className="relative overflow-hidden"
                style={{
                    backgroundImage: `url('${HERO_IMAGE}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="hero-overlay">
                    <div className="max-w-md mx-auto md:max-w-2xl lg:max-w-5xl px-5 py-16 md:py-24 text-white text-center">
                        <div className="flex justify-center mb-4">
                            <Logo size={72} />
                        </div>
                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
                            تسالي سكة 10
                        </h1>
                        <p className="mt-3 text-base sm:text-lg lg:text-xl opacity-95 max-w-xl mx-auto">
                            اطلب وجباتك المفضلة... ونوصلك بكل سهولة
                        </p>
                        <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
                            <Link
                                to="/menu"
                                data-testid="hero-order-now"
                                className="btn-brand text-base px-6 py-3"
                            >
                                <i className="fa-solid fa-utensils ms-2" /> ابدأ الطلب الآن
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Categories preview */}
            <section className="max-w-md mx-auto md:max-w-2xl lg:max-w-5xl px-4 py-10">
                <div className="flex items-end justify-between mb-6">
                    <h2 className="section-title text-2xl sm:text-3xl">أقسام المنيو</h2>
                    <Link to="/menu" className="text-brand font-bold text-sm hover:underline" data-testid="link-all-menu">
                        عرض الكل ←
                    </Link>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                    {CATEGORIES.map((c) => (
                        <Link
                            to={`/menu?cat=${c.key}`}
                            key={c.key}
                            data-testid={`home-category-${c.key}`}
                            className="surface-card overflow-hidden group"
                        >
                            <div
                                className="h-24 sm:h-28 bg-cover bg-center group-hover:scale-105 transition-transform duration-500"
                                style={{ backgroundImage: `url('${c.image}')` }}
                            />
                            <div className="p-3 text-center">
                                <div className="text-text-main font-extrabold text-base">
                                    <i className={`fa-solid ${c.icon} ms-1 text-brand`} /> {c.name}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            {/* Featured */}
            {featured.length > 0 && (
                <section className="max-w-md mx-auto md:max-w-2xl lg:max-w-5xl px-4 pb-10">
                    <h2 className="section-title text-2xl sm:text-3xl mb-6">الأكثر طلباً</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {featured.map((it) => (
                            <ProductCard key={it.id} item={it} />
                        ))}
                    </div>
                </section>
            )}

            {/* CTA strip */}
            <section className="max-w-md mx-auto md:max-w-2xl lg:max-w-5xl px-4 pb-10">
                <div className="surface-card p-6 text-center bg-gradient-to-l from-[#FFF8F0] to-white">
                    <div className="text-brand text-3xl mb-2">
                        <i className="fa-solid fa-motorcycle" />
                    </div>
                    <h3 className="text-xl font-black text-text-main">جاهزين نوصلك بأسرع وقت</h3>
                    <p className="text-text-muted mt-1">اختر أصنافك وأكمل طلبك بخطوات بسيطة</p>
                    <Link to="/menu" className="btn-brand inline-block mt-4" data-testid="cta-order">
                        <i className="fa-solid fa-utensils ms-2" /> تصفح المنيو
                    </Link>
                </div>
            </section>
        </div>
    );
}
